module.exports = __webpack_public_path__ + "static/media/casa_giardino_miniatura.142d1169.jpg";